export function shorty(text : string, length : number, placeholder : string = '...'){

	if(text.length <= length){
		return text;
	}

	let l = length / 2;

	return text.substr(0, l) + placeholder + text.substr(-l);

}